import { Component, OnInit } from '@angular/core';
import { ComprobanteService } from 'src/app/DataAccess/comprobantes.service';
import { DatosDocumento } from 'src/app/Model/datosDocumento.model';

@Component({
  selector: 'app-prueba',
  templateUrl: './prueba.component.html',
  styleUrls: ['./prueba.component.css']
})
export class PruebaComponent implements OnInit {

  constructor(private generarComprobante:ComprobanteService) { }

  ngOnInit(): void {
  }


  enviarCorreo() {
    let datos = new DatosDocumento()

    datos.RUC = '20527828563'
    datos.TipoComprobante = 3
    datos.SerieNumero = 'B001-023298'

    datos.FechaEmision = new Date('2023-06-19 00:00:00.000');
    datos.MontoTotal = 44.80
    datos.TokenDB = 'Q3V6bWFyREI='
    datos.Servidor = 'https://yachaywebservices.com'
    datos.NombreDB = 'CuzmarDB'
    datos.NroCelular = '51974409679'
    datos.FechaEmision = new Date('2023-06-19 00:00:00.000');
    datos.NumeroDescargas = 0

    this.generarComprobante.enviarWhatsapp(datos).subscribe(
      data => {
        console.log('datos enviados correctamente')
      }, error => {
        console.log(error)
      }, () => { }
    )

  }

  existeIdItem() {
    this.generarComprobante.existeId('6ae93235-9f98-441e-a0c3-39a00461ab5c').subscribe(
      data => {
        console.log(data)
      }, error => {
        console.log(error)
      }, () => { }
    )
  }
}
